import axios from 'axios';

const api = axios.create({
    // Vercel will inject REACT_APP_API_URL when live. 
    // If it's not there, it defaults to your local server!
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
});

// This interceptor automatically adds the token to every request
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`; // Or whatever your backend expects
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;